import { ClientJS } from 'clientjs';

const FingerPrinter = {
    get: async () => {
        let client = new ClientJS();
        return client.getBrowser() + ' ' + client.getFingerprint();
    }
}

export default FingerPrinter;